// Support / Donate page content.
// NOTE: PLACEHOLDER / FILLER data for design-demo purposes only. Amounts, impact
// statements, allocation percentages and stats are illustrative and should be
// replaced with the client's real figures. No real payment processing is wired up.

export const SUPPORT_INTRO = {
  eyebrow: "",
  title: "Give to Grow",
  lede:
    "Your gift gives immigrant and refugee farmers the land, training, and tools to grow thriving, independent farm businesses \u2014 and feed their communities.",
  heroImage: "/images/wf/vlai/vlai-3895.jpg",
  heroAlt: "A farmer in a sun hat picks peppers from a leafy plant.",
  sideImage: "/images/wf/who-we-are.jpg",
  sideAlt: "A smiling farmer carrying a large bag of freshly harvested corn beside a car at the edge of a field.",
};

export const DONATION_PRESETS = [25, 50, 100, 250];

export const WAYS_TO_GIVE = [
  { id: "in-kind", icon: "package", title: "Donate goods", text: "Seeds, tools, and equipment keep new farm businesses growing.", action: "contact" },
  { id: "corporate", icon: "building", title: "Corporate sponsorship", text: "Partner your business with a mission your customers and team will love.", action: "contact" },
  { id: "legacy", icon: "landmark", title: "Legacy giving", text: "Include World Farmers in your planned giving and leave a lasting harvest.", action: "contact" },
];

export const ALLOCATION = [
  { label: "Farmer programs & training", pct: 82 },
  { label: "Fundraising", pct: 10 },
  { label: "Administration", pct: 8 },
];

export const SUPPORT_STATS = [
  { value: "1,200+", label: "farmers supported" },
  { value: "400+", label: "acres cultivated" },
  { value: "40+", label: "markets served" },
  { value: "30+", label: "cultures represented" },
];
